import { Injectable } from '@angular/core';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationPreparationNeededPluginService extends InspectionPluginService {
  private preparationsKeys = [
    { value: 1, label: 'plugins.installationpreparationneeded.none' },
    { value: 2, label: 'plugins.installationpreparationneeded.dismantling' },
    { value: 3, label: 'plugins.installationpreparationneeded.displacing' }
  ];

  private preparations = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getPreparations() {
    return this.preparations;
  }

  public updatePreparation(inspectionId: string, pointId: string, pluginId: string, preparation: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, preparation).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.preparations = [];
    this.copyTranslationValues(this.preparationsKeys, this.preparations, this.language);
  }
  private update(inspectionId: string, pointId: string, pluginId: string, preparation: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, preparation).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
